/*
 * df-polish.js — JS polish frontend global
 *
 * 1. Lazy image fade-in
 * 2. Skip-to-main accessibility helper
 * 3. Scroll-to-anchor offset (con sticky header)
 * 4. Smooth scroll para internal links
 * 5. Detección touch device (clase en html)
 * 6. Detección scroll position (clase scrolled en html)
 *
 * Defer loaded — no bloquea render.
 */

(function () {
  'use strict';

  // ===== 1. Lazy image fade-in =====
  function markLoaded(img) { img.classList.add('loaded'); }
  function initLazyImages() {
    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        markLoaded(img);
      } else {
        img.addEventListener('load', function () { markLoaded(img); }, { once: true });
        img.addEventListener('error', function () { markLoaded(img); }, { once: true });
      }
    });
  }

  // ===== 2. Touch device detection =====
  function detectTouch() {
    var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
    document.documentElement.classList.toggle('df-touch', isTouch);
    document.documentElement.classList.toggle('df-no-touch', !isTouch);
  }

  // ===== 3. Scroll position class (para sticky header transitions) =====
  function initScrollClass() {
    var lastScrollY = 0;
    var ticking = false;
    function update() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      document.documentElement.classList.toggle('df-scrolled', y > 4);
      document.documentElement.classList.toggle('df-scrolled-deep', y > 200);
      // Direction
      if (y > lastScrollY && y > 80) {
        document.documentElement.classList.add('df-scrolling-down');
        document.documentElement.classList.remove('df-scrolling-up');
      } else if (y < lastScrollY) {
        document.documentElement.classList.add('df-scrolling-up');
        document.documentElement.classList.remove('df-scrolling-down');
      }
      lastScrollY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  // ===== 4. Internal anchor smooth scroll con offset =====
  function initAnchorScroll() {
    document.body.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]:not([href="#"])');
      if (!link) return;
      var hash = link.getAttribute('href');
      if (hash.length < 2) return;
      var target = document.querySelector(hash);
      if (!target) return;
      e.preventDefault();
      var offset = parseInt(getComputedStyle(target).scrollMarginTop) || 80;
      var top = target.getBoundingClientRect().top + window.pageYOffset - 12;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: top, behavior: prefersReduced ? 'auto' : 'smooth' });
      // Update URL hash without jump
      if (history.pushState) history.pushState(null, '', hash);
    });
  }

  // ===== 5. Keyboard navigation class (focus visible refinado) =====
  function initKeyboardNav() {
    document.body.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') {
        document.documentElement.classList.add('df-keyboard');
        document.documentElement.classList.remove('df-mouse');
      }
    });
    document.body.addEventListener('mousedown', function () {
      document.documentElement.classList.add('df-mouse');
      document.documentElement.classList.remove('df-keyboard');
    });
  }

  // ===== 6. Auto-resize iframes (YouTube/Vimeo embedded) =====
  function initIframeWrap() {
    document.querySelectorAll('iframe[src*="youtube"], iframe[src*="vimeo"]').forEach(function (iframe) {
      if (iframe.dataset.dfWrapped) return;
      iframe.dataset.dfWrapped = '1';
      if (!iframe.style.aspectRatio) iframe.style.aspectRatio = '16/9';
      iframe.style.width = '100%';
      iframe.style.height = 'auto';
    });
  }

  // ===== 7. Mejorar accesibilidad: añadir aria-label a botones sin texto =====
  function fixA11y() {
    document.querySelectorAll('button, [role="button"], a').forEach(function (el) {
      if (el.textContent.trim()) return;
      if (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby')) return;
      // Si tiene solo SVG, usar el title si existe
      var svg = el.querySelector('svg title, svg[aria-label]');
      if (svg) {
        var label = svg.tagName === 'svg' ? svg.getAttribute('aria-label') : svg.textContent;
        if (label) el.setAttribute('aria-label', label);
      }
    });
  }

  // ===== INIT =====
  function init() {
    initLazyImages();
    detectTouch();
    initScrollClass();
    initAnchorScroll();
    initKeyboardNav();
    initIframeWrap();
    fixA11y();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', function () {
    initLazyImages();
    initIframeWrap();
    fixA11y();
  });
})();
